import styled from "styled-components";

export const TabContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const TabList = styled.div`
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
`;

export const Tab = styled.button`
  flex: 1;
  padding: 12px 20px;
  background-color: ${({ $active }) => ($active ? "#fff" : "#f8f9fa")};
  color: ${({ $active }) => ($active ? "#ed3241" : "#6c757d")};
  border: none;
  border-bottom: ${({ $active }) =>
    $active ? "3px solid #ed3241" : "3px solid transparent"};
  cursor: pointer;
  font-weight: ${({ $active }) => ($active ? "600" : "400")};
  font-size: 14px;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    background-color: ${({ $active }) => ($active ? "#fff" : "#e9ecef")};
    color: ${({ $active }) => ($active ? "#ed3241" : "#495057")};
  }

  /* Active tab indicator */
  ${({ $active }) =>
    $active &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background-color: #ed3241;
    }
  `}
`;
